import { render, staticRenderFns } from "./CreatorShopProductTile.vue?vue&type=template&id=cd7ffc38&scoped=true"
import script from "./CreatorShopProductTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatorShopProductTile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreatorShopProductTile.vue?vue&type=style&index=0&id=cd7ffc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7ffc38",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,CDivider: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CDivider/CDivider.vue').default,CCardText: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCardText.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default})
